import { ApiRoute } from 'config';
import { UserContext, ContextValue } from 'contexts/CurrentUser';
import createUseContextHook from './createUseContextHook';

const useCurrentUser = createUseContextHook<ContextValue>(
  // @ts-expect-error TODO: fix null safety
  UserContext,
  ApiRoute.CURRENT_USER,
);

export default useCurrentUser;
